export default [{
  key: 'desc',
  value: 'desc',
  label: 'Latest',
},
{
  key: 'asc',
  value: 'asc',
  label: 'Earliest',
}];
